import { inject } from '../../container/inject';
import { IPrimitiveStore, IPrimitiveStoreFactory, PrimitiveStoreToken } from '../interface/IPrimitiveStore';

export function injectPrimitive<Type>(defaultValue: Type): IPrimitiveStore<Type> {
  return inject<IPrimitiveStoreFactory<Type>>(PrimitiveStoreToken)(defaultValue);
}
